export default __webpack_public_path__ + "static/media/filmage-home.b06fcdd6.jpg";